import React from 'react';
import { Container, Col } from '../';
import { Theme } from '../theme';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const GA_CATEGORY = 'Header Menu';

const DropdownCol = Col.extend`
  line-height: 1.9;
  padding-top: 5px;
  padding-botton: 5px;
`;

const DrodownRow = Col.extend`
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 180px;
  border-bottom: 1px solid #eee;
`;

const DropdownLink = styled.a`
  color: #2f3034;
  text-decoration: none;
  line-height: 1.9;
  &:hover {
    opacity: 0.8;
  }
`;

const MessagesNumber = styled.span`
  color: ${Theme.snow};
  background-color: ${Theme.danger};
  border-radius: 4px;
  padding: 1px 3px;
  float: right;
  line-height: 1.5;
  margin: 4px 0;
`;

const LoginDropdown = ({
  user_role,
  inspiration_board_web_path,
  siteSource,
  showMessageLink,
  numberMessages
}) => (
  <Container style={{ padding: 0, textAlign: 'left' }}>
    {user_role !== 'advertiser' && (
      <DrodownRow className="hover-menu__list">
        <DropdownCol xs={12}>
          <DropdownLink
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Advertiser Center`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            href="/account"
          >
            Advertiser Center
          </DropdownLink>
        </DropdownCol>
        <DropdownCol xs={12}>
          <DropdownLink
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Manage Leads`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            href="/account/leads"
          >
            Manage Leads
          </DropdownLink>
        </DropdownCol>
      </DrodownRow>
    )}
    <DrodownRow className="hover-menu__list">
      <DropdownCol xs={12}>
        <DropdownLink
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - My Jobs`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          href="/account/jobs"
        >
          Jobs
        </DropdownLink>
      </DropdownCol>
      {showMessageLink && (
        <DropdownCol xs={12}>
          <DropdownLink
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - Message Centre`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            href="/message_centre"
          >
            Messages
            {numberMessages > 0 && <MessagesNumber>{numberMessages}</MessagesNumber>}
          </DropdownLink>
        </DropdownCol>
      )}
      <DropdownCol xs={12}>
        <DropdownLink
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - Your Friends`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          href="/feed"
        >
          Find Friends
        </DropdownLink>
      </DropdownCol>
      <DropdownCol xs={12}>
        <DropdownLink
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - My Inspiration Boards`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          href={inspiration_board_web_path}
        >
          Inspiration Boards
        </DropdownLink>
      </DropdownCol>
      <DropdownCol xs={12}>
        <DropdownLink
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - My Contacts`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          href="/account/contacts"
        >
          Contacts
        </DropdownLink>
      </DropdownCol>
    </DrodownRow>
    <DrodownRow className="hover-menu__list">
      <DropdownCol>
        <DropdownLink
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked User Menu - My Edit Profile`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          href="/account/edit"
        >
          Edit Profile
        </DropdownLink>
      </DropdownCol>
      <DropdownCol>
        <DropdownLink
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked User Menu - Change Password`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          href="/account/change-password"
        >
          Change Password
        </DropdownLink>
      </DropdownCol>
      <DropdownCol>
        <DropdownLink
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked Clicked User Menu - Unsubscribe`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          href="/account/subscribe"
        >
          Unsubscribe
        </DropdownLink>
      </DropdownCol>
    </DrodownRow>
    <DrodownRow className="hover-menu__list">
      <DropdownCol>
        <DropdownLink
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked Clicked User Menu - Logout`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          href="/account/?m=public&a=logout"
        >
          Logout
        </DropdownLink>
      </DropdownCol>
    </DrodownRow>
  </Container>
);

LoginDropdown.propTypes = {
  user_role: PropTypes.string,
  inspiration_board_web_path: PropTypes.string,
  siteSource: PropTypes.string,
  showMessageLink: PropTypes.bool,
  numberMessages: PropTypes.number
};

export default LoginDropdown;
